<app-master-data-table [data]="this.masterCommonService.hsnList" [columns]="hsnColumns" title="Hsn List"
  addButtonLabel="Hsn" (add)="openAddUpdateHsnDialog('add')"
  (update)="openAddUpdateHsnDialog('update', $event)" (delete)="deleteHsn($event)">
</app-master-data-table>
